import { render, staticRenderFns } from "./PBSnackbar.vue?vue&type=template&id=05466892&scoped=true&"
import script from "./PBSnackbar.vue?vue&type=script&lang=js&"
export * from "./PBSnackbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05466892",
  null
  
)

export default component.exports